<div class="sig-tab">

  <div class="sig-loading" *ngIf="loading">
    <mat-spinner diameter="26"></mat-spinner>
  </div>

  <ng-container *ngIf="!loading">

    <!-- The limitation is stated up front rather than left for someone to discover -->
    <p class="sig-explainer">
      <mat-icon>info_outline</mat-icon>
      <span>
        Outlook doesn't let apps read your saved signature, so Klidi builds one from your
        Microsoft 365 details instead. Edit it here, then copy it into Outlook.
      </span>
    </p>

    <div class="sig-empty" *ngIf="candidates.length === 0">
      <mat-icon>draw</mat-icon>
      <p>Couldn't build a signature — your Microsoft 365 profile didn't return any details.</p>
      <button mat-stroked-button (click)="refresh()">
        <mat-icon>refresh</mat-icon><span>Try again</span>
      </button>
    </div>

    <ng-container *ngIf="candidates.length > 0">

      <nav class="sig-candidates" *ngIf="candidates.length > 1">
        <button *ngFor="let candidate of candidates; let i = index"
                class="sig-candidate"
                [class.sig-candidate--active]="i === selectedIndex"
                [attr.aria-pressed]="i === selectedIndex"
                (click)="select(i)">
          <mat-icon>{{ candidate.source === 'derived' ? 'badge' : 'history_edu' }}</mat-icon>
          <span>{{ candidate.source === 'derived' ? 'From profile' : 'From sent mail' }}</span>
        </button>
      </nav>

      <div class="sig-provenance" *ngIf="selected">
        <strong>{{ selected.label }}</strong>
        <span>{{ selected.hint }}</span>
        <span class="sig-confidence sig-confidence--low"
              *ngIf="selected.source === 'detected' && selected.confidence !== 'high'">
          Low-confidence match — read it carefully.
        </span>
      </div>

      <div class="sig-preview-wrap">
        <div class="sig-section-head">
          <h4>Preview</h4>
          <button mat-button (click)="toggleEdit()">
            <mat-icon>{{ editing ? 'visibility' : 'edit' }}</mat-icon>
            <span>{{ editing ? 'Done editing' : 'Edit HTML' }}</span>
          </button>
        </div>

        <iframe class="sig-preview" sandbox="" referrerpolicy="no-referrer"
                [srcdoc]="preview" title="Signature preview"></iframe>

        <textarea *ngIf="editing"
                  class="sig-editor"
                  rows="10"
                  spellcheck="false"
                  [(ngModel)]="draftHtml"
                  aria-label="Signature HTML"></textarea>
      </div>

      <div class="sig-actions">
        <button mat-flat-button color="primary" (click)="copy()">
          <mat-icon>content_copy</mat-icon><span>Copy signature</span>
        </button>
        <button mat-stroked-button (click)="openOutlookSignatureSettings()">
          <mat-icon>open_in_new</mat-icon><span>Open Outlook signature settings</span>
        </button>
        <button mat-button *ngIf="editing || draftHtml !== selected?.html" (click)="resetDraft()">
          <mat-icon>undo</mat-icon><span>Reset</span>
        </button>
      </div>

    </ng-container>
  </ng-container>
</div>
